// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__J1LZ1","left":"Contact_left__Wd4Na","right":"Contact_right__Xrc4k"};